import { Injectable } from '@angular/core';
import { DataSourceRequestState, SortDescriptor, DataResult, translateDataSourceResultGroups } from '@progress/kendo-data-query';
import { Observable, of } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AccountingLogService {
    constructor(
        private auth: AuthService,
        private httpRepo: HttpRepo
    ) {
        this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
    }
    // // GET all integrations
    public GetIntegrations(state: DataSourceRequestState, searchKey: string) {
        return this.httpRepo.Get("integrations", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
    }

    public GetIntegration(data: any) {
        return this.httpRepo.Get("integrations/" + data.ID);
    }

    public PostIntegration(data: any) {
        data.ID='00000000-0000-0000-0000-000000000000';
        return this.httpRepo.Post("integrations", data);
    }

    public FetchIntegrations(integrationsListData: any, state: DataSourceRequestState, sort: SortDescriptor[]): Observable<DataResult> {
        const hasGroups = state.group && state.group.length;
        return of({ data: integrationsListData.integrationCommands, total: integrationsListData.Count }) // Send the state to the server
            .map(({ data, total }: GridDataResult) => // Process the response
                (<GridDataResult>{
                    data: hasGroups ? translateDataSourceResultGroups(data) : data,
                    total: total,
                })
            )
    }
}